// for general Cards:
export const QUANTITIES = [
  20,
  30,
  40,
  50,
  60,
  70,
  80,
  90,
  100,
  110,
  120,
  130,
  140,
  150,
  160,
  170,
  180,
  190,
  200,
  210,
  220,
  230,
  240,
  250,
  260,
  270,
  280,
  290,
  300,
  310,
  320,
  330,
  340,
  350,
  360,
  370,
  380,
  390,
  400,
];
export const QUANTITY_OPTIONS = QUANTITIES.map(quantity => ({
  label: quantity.toString(),
  value: quantity,
}));
export const DEFAULT_PAPER_TYPE_VALUE = 'smooth'; // use smooth as default to prevent bug with foil cards that dont have eggshell paper-type as an option
export const DEFAULT_SHAPE_VALUE = 'square';

export const ALL_FILTER_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN',
  'GREY',
  'ORANGE',
  'PINK',
  'PURPLE',
  'RED',
  'WHITE',
  'YELLOW',
];

export const TEXT_ALIGNMENT_OPTIONS = ['LEFT', 'CENTER', 'RIGHT'];
export const BACK_PRINTING_PRICE = 35;

export const PAGES = ['FRONT', 'INSIDE', 'WRITE', 'BACK', 'RSVP', 'RSVP ENVELOPE', 'ENVELOPE'];
export const PAGE_URLS = {
  FRONT: 'detailFront',
  INSIDE: 'detailInside',
  WRITE: 'detailWrite',
  BACK: 'detailBack',
  RSVP: 'rsvp',
  'RSVP ENVELOPE': 'rsvpEnvelope',
  ENVELOPE: 'envelope',
};

// for PLP:
export const ALL_COLORS = [
  'BLUE',
  'GREEN',
  'BLACK',
  'PINK',
  'PURPLE',
  'WHITE',
  'RED',
  'BEIGE',
  'GREY',
  'ORANGE',
  'YELLOW',
  'BROWN',
];

export const BASE_URL = '/wedding-planning';

export const CARD_SIZES = {
  petite: 'petite',
  classic: '5x7',
  folded: 'folded-petite',
  postcard: 'postcard',
};



// WEBPACK FOOTER //
// ./src/cards/constants/Cards.js